import styles from "./NewUserForm.module.css";
import { useState, useContext, useEffect } from "react";
import Modal from "../../components/Modal/Modal";
import { AuthContext } from "../../contexts/auth.context";
import authService from "../../services/auth.service";
import { useNavigate } from "react-router-dom";
import ScreenHeader from "../../components/ScreenHeader/ScreenHeader";

const emptyUser = {
  name: "",
  email: "",
  password: "",
};

function NewUserForm() {
  const { isAdmin, setIsLoading } = useContext(AuthContext);
  const [modalVisible, setModalVisible] = useState(false);
  const [signupData, setSignupData] = useState(emptyUser);
  const navigate = useNavigate();

  useEffect(() => {
    if (!isAdmin) {
      navigate("/dashboard");
    }
  }, [isAdmin, navigate]);

  const handleInputChange = (e) => {
    const { value, name } = e.target;
    setSignupData({ ...signupData, [name]: value });
  };

  const _handleFormSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);
    authService
      .signup(signupData)
      .then(() => {
        setModalVisible(true);
        setSignupData(emptyUser);
      })
      .catch((err) => console.log(err.response?.data?.errorMessages))
      .finally(() => setIsLoading(false));
  };

  return (
    <>
      <Modal
        isOpen={modalVisible}
        onClose={() => setModalVisible(false)}
        type="success"
      >
        <p>Usuario creado con éxito.</p>
      </Modal>

      <div className={styles.container}>
        <ScreenHeader title="Nuevo usuario" />

        <form className={styles["signup-form"]} onSubmit={_handleFormSubmit}>
          <input
            className={styles.input}
            type="text"
            name="name"
            placeholder="Nombre"
            value={signupData.name}
            onChange={handleInputChange}
            required
          />
          <input
            className={styles.input}
            type="email"
            name="email"
            placeholder="Email"
            value={signupData.email}
            onChange={handleInputChange}
            required
          />
          <input
            className={styles.input}
            type="password"
            name="password"
            placeholder="Contraseña"
            value={signupData.password}
            onChange={handleInputChange}
            required
          />
          <button className={styles.submitButton} type="submit">Crear</button>
        </form>
      </div>
    </>
  );
}

export default NewUserForm;
